import { Box, Container, Grid, Typography } from "@mui/material";
import { useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { APP_ID } from "../../../../config/constants";
import { getEventAction } from "../../../../store/actions/events";
import { getPostsAction } from "../../../../store/actions/poll";
import EventItem from "./EventItem";

export default function Events() {
  const dispatch = useDispatch();

  const posts = useSelector((s) => s.posts.data.byId);
  const allIds = useSelector((s) => s.posts.data.allIds);
  const loading = useSelector((s) => s.posts.loading);

  const events = useSelector((s) => s.events.data);
  const loadingEvents = useSelector((s) => s.events.loading);
  const error = useSelector((s) => s.events.error);

  const fetchPost = useCallback(
    ({ page, next, searchText }) => {
      getPostsAction({
        page,
        limit: 6,
        next,
        type: "events",
        text: searchText || undefined,
        pageId: 183,
      })(dispatch);
    },
    [dispatch]
  );
  useEffect(() => {
    return fetchPost({ page: 1 });
  }, [fetchPost]);

  const fetchEvents = useCallback(
    ({ page, searchText }) => {
      getEventAction({
        page,
        limit: 6,
        text: searchText || undefined,
        appId: APP_ID,
      })(dispatch);
    },
    [dispatch]
  );
  useEffect(() => {
    return fetchEvents({ page: 1 });
  }, [fetchEvents]);

  return (
    <Box
      sx={{
        backgroundImage: "url(/images/home/eventsBg.png)",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        width: 1,
        pt: 4,
        mb: 7,
      }}
    >
      <Container maxWidth="xl">
        <Grid container spacing={2}>
          {events?.length === 0 && !loadingEvents && (
            <Grid
              item
              xs={12}
              lg={11}
              display="flex"
              alignItems="center"
              justifyContent="center"
              flexDirection="column"
              sx={{ my: 1 }}
            >
              <Typography variant="body1" sx={{ my: 2 }} component="div">
                No events yet
              </Typography>
            </Grid>
          )}

          {events?.length > 0 &&
            events?.map((event) => {
              return (
                <Grid key={event?.id} item xs={12} md={4} sx={{ height: 1 }}>
                  <EventItem
                    event={{
                      ...event,
                      attachments: event?.attachments,
                    }}
                    coverPhoto={event?.image}
                  />
                </Grid>
              );
            })}
        </Grid>
      </Container>
    </Box>
  );
}
